<template>
  <v-row class="d-flex justify-center ma-0 pa-0" >
    
    <v-col cols="12" class="pa-0 ma-0">
      <Banner :banner="banner" />
    </v-col>

      <v-col cols="12" md="10" xl="8">
        <!-- //news -->
        <div v-if="fbdata.facebookActive == null || fbdata.facebookActive == false">
          <newsMessage
            title-name="最新消息"
            piece="8"
            class="pa-0 ma-0"
            :news="message"
            :moreurl="{ name: '最新消息', url: '/newsMessageAll' }"
            :previousPageUrl="'Home'"
          />
        </div>
      </v-col>
      
      <v-row class="gradient pa-0 ma-0"
       v-if="data_1 && data_1.content && data_1.content.length != 0">

        <v-col cols="12" class="home_up_BG-img pa-0 ma-0" :class="isMobile? 'h-10vh':'h-20vh'"></v-col>
        
        <!-- 內容1　有背景的內容 -->
        <v-row cols="12" class="pa-0 ma-0 d-flex justify-center mb-12">
          <v-col cols="12" md="10" xl="8">
            <allcent
              class="px-0 px-md-0" 
              :allData="data_1.content"
              :titleStyle="data_1_titleStyle"
              :subheadStyle="data_1_secondStyle"/>
          </v-col>
        </v-row>
        
        <v-col cols="12" class="home_bottom_BG-img  pa-0 ma-0 mt-4" :class="isMobile? 'h-10vh':'h-20vh'"
         v-if="data_2 && data_2.content.length != 0"></v-col>

      </v-row>
      
      <!-- 內容2　白底的內容 -->
      <v-col cols="12" md="10" xl="8" v-if="data_2 && data_2.content.length != 0"
      class="mb-12">
        <allcent
          class="px-0 px-md-0" 
          :allData="data_2.content"
          :titleStyle="data_2_titleStyle"
          :subheadStyle="data_2_secondStyle"/>
      </v-col>

  </v-row>
</template>
<script>
  import axios from 'axios';
  import { mapState, mapMutations } from "vuex";
  import Banner from "../components/banner.vue";
  import newsMessage from "../components/newsMessage.vue";
  
  import allcent from "@/components/allComponent.vue";
  
    export default {
      name: 'Home',

      components: {
        newsMessage,
        Banner,
        allcent,
      },

      data: () => ({
        message: "", //最新消息
        fbdata: {}, //??
        testMode: 0, //??
        
        //banner用
        banner: null,

        //內容使用
        data_1: null,
        data_1_titleStyle:"font-h2 color-bg-title rounded-pill px-8 px-md-14",
        data_1_secondStyle:"font-h3ti color-title",
        
        data_2: null,
        data_2_titleStyle:"font-h2 color-title",
        data_2_secondStyle:"font-h3 color-subtitle",


      }),
      created() {
        this.$store.commit("scrollToTop");
      },
      mounted(){ 
        this.getData();
        this.getnewsMessage();

        //抓頁籤名稱
        document.getElementById("pageTitle").innerHTML = this.$store.state.deptName;
        if (this.$store.state.lang == "en") {
          if (location.href.indexOf("#reloaded") == -1) {
            location.href = location.href + "#reloaded";
            location.reload();
          }
        }
        if (
          location.href.indexOf("local") != -1 ||
          location.href.indexOf("8080") != -1 ||
          location.href.indexOf("wm") != -1
        )
          this.testMode = true;
        else this.testMode = false;
        
      },
    
      computed: {
        isMobile() {
          return this.$vuetify.breakpoint.smAndDown; // 当屏幕宽度小于 "md" 断点时返回 true
        },
        ...mapState([
          "poolId",
          "mediaPoolID",
          "activityPoolID",
          "siteSettingSuccess",
          "mediaIsActive",
          "activityIsActive",
          "facebookActive",
          "facebook"
        ]),
       
      },
      
      watch: {
        siteSettingSuccess: function() {
          
          this.getnewsMessage();
          

          this.getMarquee();
          this.getFastLink();
        }
        
      },
  
      methods:{
        //處裡取得的 index 資料
        getData() {
          axios.get("/tools/json/index.json")
            .then((response) => {
              // 成功處理回應數據
              this.banner = response.data[0];
              this.data_1 = response.data[1];
              if(response.data[2].content)
                this.data_2 = response.data[2];
            })
            .catch((error) => {
              // 處理錯誤
              console.error("資料獲取失敗", error);
            });
        },
  
        //取得最新消息 url: "tools/json/newsMessage.json",
        getnewsMessage() {
          var self = this;
          if (location.hostname == "localhost") {
            axios({
              method: "post",
              baseURL: "",
              url: "https://tis.dyu.edu.tw/app/app/news.php",
              "Content-Type": "application/json",
              data: {
                pool_ID: self.poolId,
                edate: "undefined",
                eitems: 15,
                sdate: "undefined",
                sitems: 0
              }
            })
              .then(result => {
                self.message = result.data;
              })
              .catch(err => {
                console.error(err);
              });
          } else {
            axios({
              method: "post",
              baseURL: "",
              url: "https://tis.dyu.edu.tw/app/app/news.php",
              "Content-Type": "application/json",
              data: {
                pool_ID: self.poolId,
                edate: "undefined",
                eitems: 15,
                sdate: "undefined",
                sitems: 0
              }
            })
              .then(result => {
                self.message = result.data;
              })
              .catch(err => {
                console.error(err);
              });
          }
        },

       
        //接收fbdata
        setFB: function(data) {
          this.fbdata = data;
        },

        
        // //marquee
        // getMarquee: async function() {
        //   const self = this;
        //   var url = "";
        //   var dateNow = new Date();

        //   //make url
        //   if (self.$store.state.isDemo) {
        //     url = "tools/json/marquee_tw.json";
        //   } else {
        //     url = "marquee/marquee_tw.json";
        //   }
        //   axios.get(url).then(result => {
        //     var tmp = result.data;
        //     tmp.sort(function(a, b) {
        //       if (a.date_stop > b.date_stop) return 1;
        //       else if (a.date_stop == b.date_stop) {
        //         if (a.date_start > b.date_start) return 1;
        //         else return -1;
        //       } else return -1;
        //     });
        //     // remove over date
        //     tmp.reduceRight(function(preItem, item, index, ary) {
        //       var dateStop = new Date(item.date_stop);
        //       var dateStart = new Date(item.date_start);
        //       if (dateNow > dateStop || dateNow < dateStart) ary.splice(index, 1);
        //     }, []);
        //     tmp.forEach(
        //       element => (self.marquee.text += " " + element.marquee_desc)
        //     );
        //   });
        // },
        getFastLink: async function() {
          const self = this;
          var dateNow = new Date();
          var url = [];
          url.push(
            "https://icloud.dyu.edu.tw/link_common/read_json.php?poolid=" +
              self.$store.state.fastLinkPoolId
          );
          url.push("https://icloud.dyu.edu.tw/link_common/read_json.php?poolid=1");
          Promise.all(url.map(item => axios.get(item))).then(result => {
            result.forEach(item => {
              if (item.data) {
                item.data.reduceRight((preItem, link, index, ary) => {
                  var dateStop = new Date(link.enddate);
                  var dateStart = new Date(item.startdate);
                  if (dateNow > dateStop || dateNow < dateStart)
                    ary.splice(index, 1);
                  else self.fastLink.push(link);
                });
              }
            });
          });
        }
        
        
      },

    
    }
</script>
<style lang="scss" scoped>
.gradient{
  background-color: var(--get-color-primary-l);
}
.home_up_BG-img{
  // height: 8vh;
  background-image: url(../../public/tools/img/doNotTouch/indexBg_standard_up.svg);
    background-repeat: no-repeat;
    background-position: top;
    background-size: contain;//依照內容最大化填滿框架，並不超出範圍 
}
.home_bottom_BG-img{
  // height: 8vh;
  background-image: url(../../public/tools/img/doNotTouch/indexBg_standard_up2.svg);
    background-repeat: no-repeat;
    background-position: bottom;
    background-size: contain;//依照內容最大化填滿框架，並不超出範圍 
}

</style>>
  